module.exports = __webpack_public_path__ + "img/ic_mfm.3189ded6.svg";